import React from "react";

type RestartProps = {
  color?: string;
};

const Restart: React.FC<RestartProps> = ({ color = "#000000" }) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.72897 19.225C5.71231 18.975 4.04164 18.0957 2.71697 16.587C1.39164 15.079 0.728973 13.3084 0.728973 11.275C0.728973 10.175 0.94564 9.12069 1.37897 8.11202C1.81231 7.10402 2.42897 6.22502 3.22897 5.47502L4.65397 6.90002C4.02064 7.46669 3.54164 8.12502 3.21697 8.87502C2.89164 9.62502 2.72897 10.425 2.72897 11.275C2.72897 12.7417 3.19564 14.0374 4.12897 15.162C5.06231 16.2874 6.26231 16.975 7.72897 17.225V19.225ZM9.72897 19.225V17.225C11.179 16.9584 12.3746 16.2667 13.316 15.15C14.258 14.0334 14.729 12.7417 14.729 11.275C14.729 9.60836 14.1456 8.19169 12.979 7.02502C11.8123 5.85836 10.3956 5.27502 8.72897 5.27502H8.65397L9.75397 6.37502L8.35397 7.77502L4.85397 4.27502L8.35397 0.775024L9.75397 2.17502L8.65397 3.27502H8.72897C10.9623 3.27502 12.854 4.05002 14.404 5.60002C15.954 7.15002 16.729 9.04169 16.729 11.275C16.729 13.2917 16.0666 15.0544 14.742 16.563C13.4166 18.071 11.7456 18.9584 9.72897 19.225Z"
        fill={color}
      />
    </svg>
  );
};

export default Restart;
